export default "__VITE_ASSET__DpTrZfDF__"